<template>
  <div class="vx-row mb-4 px-3">
    <div class="lg:w-1/4 md:w-1/2 w-full px-2">
      <label class="vs-select--label datepicker-lb">{{ $t("BasketId") }}</label>
      <vs-input
        class="inputx pt-1"
        @keyup.enter="submitFilter()"
        v-model="gridSearchData.BasketId"
        v-trim-space
      />
    </div>
    <div class="lg:w-1/4 md:w-1/2 w-full px-2">
      <label class="vs-select--label datepicker-lb">{{
        $t("RecipientName")
      }}</label>
      <vs-input
        @keyup.enter="submitFilter()"
        class="inputx pt-1"
        v-model="gridSearchData.RecipientName"
        v-trim-space
      />
    </div>
    <div class="lg:w-1/4 md:w-1/2 w-full px-2">
      <label class="vs-select--label datepicker-lb">{{ $t("FromDate") }}</label>
      <date-picker
        v-model="gridSearchData.FromDate"
        type="datetime"
        format="jYYYY-jMM-jDD HH:mm:ss"
        display-format="jYYYY-jMM-jDD HH:mm:ss"
        class="date-picker m-0 p-0"
        :label="$t('FromDate')"
        :clearable="true"
      />
    </div>
    <div class="lg:w-1/4 md:w-1/2 w-full px-2">
      <label class="vs-select--label datepicker-lb">{{ $t("ToDate") }}</label>
      <date-picker
        v-model="gridSearchData.ToDate"
        type="datetime"
        format="jYYYY-jMM-jDD HH:mm:ss"
        display-format="jYYYY-jMM-jDD HH:mm:ss"
        class="date-picker"
        :label="$t('ToDate')"
        :clearable="true"
      />
    </div>
    <!-- </div> -->
    <div class="lg:w-1/2 w-full my-1 px-2">
      <vs-input
        class="inputx"
        @keyup.enter="submitFilter()"
        v-model="gridSearchData.Description"
        :label="$t('Description')"
        v-trim-space
      />
    </div>
    <div class="lg:w-1/2 w-full pt-6 px-2">
      <div>
        <vs-button
          @click.prevent="downloadFile()"
          class="float-right bg_l_purple p-3"
          v-has-permission="permission1"
        >
          {{ $t("DownloadExcelFile") }}
        </vs-button>
        <vs-button
          type="filled"
          class="float-right mx-3"
          @click.prevent="submitFilter()"
          >{{ $t("SubmitFilter") }}</vs-button
        >
        <vs-button
          type="filled"
          class="float-right btn_l_blue"
          @click.prevent="resetForm"
          >{{ $t("ResetFilter") }}</vs-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import vSelect from "vue-select";
export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    "v-select": vSelect,
  },
  props: {
    gridSearchDataManual: {},
    PackageQueryState: "",
  },
  data() {
    return {
      permission1: "GetPackagesWithExcel",
      gridSearchData: {},
      filterText: "?PackageQueryState=",
    };
  },
  mounted() {
    if (this.gridSearchDataManual) {
      this.gridSearchData = this.gridSearchDataManual;
    }
  },
  methods: {
    ...mapActions({
      exportExcelPackage: "excel/exportExcelPackage",
    }),
    submitFilter() {
      this.$emit("renderGridWithFilter", this.gridSearchData);
    },
    resetForm() {
      this.gridSearchData = {};
      this.submitFilter();
    },
    downloadFile() {
      this.setFilterForDownloafFile();
      this.exportExcelPackage(this.filterText).then(() => {});
    },
    setFilterForDownloafFile() {
      this.filterText = "?PackageQueryState=";
      this.filterText += this.PackageQueryState;
      for (let key in this.gridSearchData) {
        if (this.gridSearchData[key]) {
          this.filterText += "&" + key + "=" + this.gridSearchData[key];
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
</style>
